export type JsonObject = Record<string, unknown>;

export function hasOnlyKeys(
  row: JsonObject,
  allowed: readonly string[],
): boolean {
  return Object.keys(row).every(key => allowed.includes(key));
}

export function object(value: unknown): JsonObject | null {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as JsonObject)
    : null;
}

export function stringOrNull(value: unknown): value is string | null {
  return value === null || typeof value === 'string';
}

export function timestampOrNull(value: unknown): value is string | null {
  return value === null || validTimestamp(value);
}

export function validTimestamp(value: unknown): value is string {
  return typeof value === 'string' && Number.isFinite(Date.parse(value));
}
